import { useRef } from "react";
import { styled } from "styled-components";

import {
  FullscreenContainer,
  FullscreenIcon,
  SectionHeadingButton,
  SourceLabelTitle,
  WebFrame,
} from "common/components";
import type { FullscreenRef } from "common/components/FullscreenContainer";
import { useTranslate } from "common/utilities/useTranslate";
import { useMedia } from "domains/viewport/useMedia";
import type { Source } from "entities/knowledge/types";

const StyledFrame = styled(WebFrame)`
  border: none;
  overflow: hidden;
  border-radius: 5px;
  height: 100%;
  padding-top: 0;
  margin: 0;
`;

const StyledFullscreenIcon = styled(FullscreenIcon)`
  width: 14px;
  height: 14px;
`;

type KnowledgeDataDetailProps = { title: string; interactiveLink?: string; source: Source; timestamp: number };

export const KnowledgeDataDetail = ({ title, interactiveLink, source, timestamp }: KnowledgeDataDetailProps) => {
  const translate = useTranslate();
  const fullscreenRef = useRef<FullscreenRef>(null);
  const isDesktop = useMedia({ small: false, medium: false }, true);

  const fullscreenButton = isDesktop ? (
    <SectionHeadingButton
      iconElement={<StyledFullscreenIcon />}
      onClick={() => fullscreenRef.current?.toggleFullscreen()}
    >
      {translate("app.fullscreen.title")}
    </SectionHeadingButton>
  ) : undefined;

  return (
    <>
      <SourceLabelTitle source={source} date={timestamp} rightElement={fullscreenButton} type="small" />
      {interactiveLink && (
        <FullscreenContainer ref={fullscreenRef}>
          <StyledFrame url={interactiveLink} title={title} forceIframe />
        </FullscreenContainer>
      )}
    </>
  );
};
